import { render, staticRenderFns } from "./BasketSection.vue?vue&type=template&id=0dcaa9a9&scoped=true&"
import script from "./BasketSection.vue?vue&type=script&lang=ts&"
export * from "./BasketSection.vue?vue&type=script&lang=ts&"
import style0 from "./BasketSection.vue?vue&type=style&index=0&id=0dcaa9a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcaa9a9",
  null
  
)

export default component.exports